import React, { useEffect, useMemo, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";

const useAccumulationCode = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialSelectMode,
  initialLookupType,
  selectParamsData
) => {
  const [data, setData] = useState([]);

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const [selectMode, setSelectMode] = useState(initialSelectMode);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [disabledDropdowns, setDisabledDropdowns] = useState({});

  const toast = useToast();
  const location = useLocation();
  const {
    ACCUMULATION_CODE_ADD,
    ACCUMULATION_CODE_EDIT,
    ACCUMULATION_CODE_DISPLAY,
  } = ROUTE_PATHS;
  const { axios_helper_no_header } = useAxios();
  const screen_title = "Accumulation Code";

  const [hideFlag, setHideFlag] = useState(false);
  const statusKey = "hiddenRecordIndicator";

  const [stateVal, setStateVal] = useState(location?.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);
  console.log("current state in form", currentState, previousState);

  const {
    selectedSchedules = [],
    previousScreen = "",
    currentIndex: initialIndex = 0,
    //  selectMode = false,
    paramsData: initialParamsData = {
      acmAccumulationCode: "",
      hiddenRecordIndicator: "Active",
    },
    externalMode: initialExternalMode = false,
  } = currentState;

  const baseParamsData = initialLookupType
  ? {
      ...selectParamsData,
      acmAccumulationCode: selectParamsData?.acmAccumulationCode || "",
      hiddenRecordIndicator: "Active",
    }
  : initialParamsData;
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const [screenNumber, setScreenNumber] = useState("RCACM001");
  const [externalScreenNumber, setExternalScreenNumber] = useState("");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(baseParamsData);

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]
      ?.acmAccumulationCode;
  const updatedParamsData = {
    ...paramsData,
    acmAccumulationCode: lastScheduleName,
  };

  const formFields = selectMode
    ? [
        {
          fieldLabel: "ACM Accumulation Code",
          name: "acmAccumulationCode",
          label: "Accumulation Code",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 10,
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          fieldNature: "editable",
          value: "",
          maxLength: 1,
        },
      ]
    : [
        {
          fieldLabel: "ACM Accumulation Code",
          name: "acmAccumulationCode",
          label: "Accumulation Code",
          type: "text",
          fieldNature: "editable",
          value: "",
          maxLength: 10,
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          fieldNature: "editable",
          value: "",
          maxLength: 1,
        },
      ];

  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    }else if (lookupType === "external") {
      const message = { type: "hideModal" };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  };

  useEffect(() => {
    if (selectMode) {
      setScreenNumber(externalScreenNumber || "RCACM005");
    }
  }, [selectMode, externalScreenNumber]);

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
     if (type === "set-params" &&  location.pathname === "/accumulation-code-external") {
      setStateVal(data);
      setExternalMode(true);
      const lastElement = data[data.length - 1];
      setParamsData({
        ...paramsData,
        acmAccumulationCode: lastElement.paramsData?.acmAccumulationCode || "",
      });
    }
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      console.log("external data", paramData, selectMode);
      setLookupType("external");
      setSelectParams(paramData.params);
      console.log("select params", selectParams);
      setParamsData({
        ...paramsData,
        acmAccumulationCode: paramData.paramsData?.acmAccumulationCode || "",
      });
      if (paramData?.screenNumber) {
        setExternalScreenNumber(paramData?.screenNumber);
      }
      setDisabledDropdowns({ hiddenRecordIndicator: true });
      // setSelectedPatient([...paramData.selectedSchedule]);
      setSelectMode(selectMode);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  const leftButtons = selectMode || externalMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  const ctaButtons = selectMode || externalMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Accumulation Code",
          button_handeler: () => {
            navigateToPage(ACCUMULATION_CODE_ADD, [
              {
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const menuOptions = useMemo(() => {
    return selectMode
      ? [
          {
            label: "Select",
            icon: <span className="material-icons">add</span>,
            command: () => {
              //addAccumulationCodes();
              // navigateToPage(ACCUMULATION_CODE_EDIT, [{
              //   // selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.acmAccumulationCode],
              //   selectedCodes: selectedRows.length ? selectedRows : [rowData],
              //   previousScreen: location.pathname,
              //   currentIndex:0,
              // }]);
              const paramDataMap = new Map();
              selectParams.forEach(key => {
              if (rowData.hasOwnProperty(key["target"])) {
                  paramDataMap.set(key["source"], rowData[key["target"]]);
              }
              });
              const paramData = Object.fromEntries(paramDataMap);
              if (lookupType === "local") {
                console.log("Hello");
                onSelect(paramData);
              } else {
                const message = {
                  type: "responseData",
                  data: paramData,
                };
                window.parent.postMessage(message, "*");
              }
            },
          },
        ]
      : [
          {
            label: "Edit",
            icon: <span className="material-icons">edit</span>,
            command: () => {
              navigateToPage(ACCUMULATION_CODE_EDIT, [
                 ...previousState,
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                  externalMode,
                },
                {
                  // selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.acmAccumulationCode],
                  selectedCodes: selectedRows.length ? selectedRows : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Delete",
            icon: <span className="material-icons">delete</span>,
            command: () => {
              openConfirmationModal();
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              navigateToPage(ACCUMULATION_CODE_DISPLAY, [
                ...previousState,
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                  externalMode,
                },
                {
                  // selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData.acmAccumulationCode],
                  selectedCodes: selectedRows.length ? selectedRows : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: rowData[statusKey] === "Hidden" ? "Unhide" : "Hide",
            icon: <span className="material-icons">visibility_off</span>,
            command: () => {
              openHideConfirmationModal();
            },
          },
        ];
  });

  const columnDef = selectMode
    ? [
        {
          header: "Code",
          field: "acmAccumulationCode",
        },
        {
          header: "Description",
          field: "acmAccumulationDesc",
        },
      ]
    : [
        {
          header: "Code",
          field: "acmAccumulationCode",
        },
        {
          header: "Description",
          field: "acmAccumulationDesc",
        },
        {
          header: "Add Date",
          field: "acmAddDate",
        },
        {
          header: "Change Date",
          field: "chgDate",
        },
        {
          header: "User",
          field: "chgUserName",
        },
        {
          header: "Status",
          field: "hiddenRecordIndicator",
        },
      ];

  const parmKey = "acmAccumulationCode";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/acmAccumulationCode`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    const isExternalAccumCode = location.pathname === "/accumulation-code-external";
    if (isExternalAccumCode && !externalMode) return;

    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, hideFlag, lookupType, externalMode, location?.pathname]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const deleteAccumulationCode = () => {
    if (selectedOption === "yes") {
      const params = { acmAccumulationCode: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/acmAccumulationCode", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          fetchData();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const hideAccumulationCode = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        acmAccumulationCode: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header(
        "PUT",
        "api/acmAccumulationCode/hideUnhide",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setHideFlag(!hideFlag);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error hiding the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData, screenNumber: screenNumber };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/acmAccumulationCode/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteAccumulationCode,
    setSelectedOption,
    selectMode: externalMode || selectMode,
    hideAccumulationCode,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    disabledDropdowns,
    displayMode: externalMode
  };
};

export default useAccumulationCode;